import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconFolder1 = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M10.944 9.387c-2.137.215-3.783 1.332-4.702 3.189-.643 1.3-.578-.895-.578 19.424s-.065 18.125.578 19.424a5.69 5.69 0 0 0 4.097 3.116c.658.124 42.664.124 43.322 0a5.69 5.69 0 0 0 4.097-3.116c.64-1.293.578.391.578-15.68V21.6l-.182-.574c-.532-1.674-1.59-2.898-3.124-3.614-1.13-.527.19-.477-13.538-.514l-12.236-.034-2.044-2.725c-1.125-1.5-2.194-2.875-2.376-3.057a5.4 5.4 0 0 0-1.575-1.118c-.694-.34-1.149-.47-1.95-.554-.553-.058-9.812-.079-10.367-.023m-.043 4.08c-.557.176-.97.556-1.15 1.055-.122.344-.12 34.617.003 34.961.137.384.46.735.857.93l.365.179h42.048l.37-.181c.413-.204.773-.615.879-1.005.042-.159.059-4.829.047-13.799-.015-12.462-.025-13.574-.122-13.751-.169-.308-.566-.679-.882-.825l-.292-.135-12.672-.032-12.672-.032-.301-.154a2.3 2.3 0 0 1-.512-.37c-.116-.12-1.277-1.634-2.579-3.366-2.324-3.09-2.375-3.152-2.747-3.341l-.38-.193-4.996-.012c-3.985-.01-5.051.004-5.264.071" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconFolder1.displayName = 'IconFolder1';